import React, { useState } from "react";
import { X, ShieldAlert, KeyRound } from "lucide-react";

const DeleteCustomerModal = ({ isOpen, onClose, onConfirm, customerName }) => {
  const [password, setPassword] = useState("");

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(password);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full max-h-[85vh] overflow-hidden flex flex-col animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="p-5 border-b dark:border-gray-700 flex justify-between items-center bg-red-50 dark:bg-gray-900/50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-100 dark:bg-red-900/40 rounded-lg">
              <ShieldAlert className="w-5 h-5 text-red-600 dark:text-red-400" />
            </div>
            <div>
              <h3 className="font-bold text-gray-800 dark:text-white leading-tight">
                Confirmar Eliminación
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400">Cliente: {customerName}</p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="p-1 text-gray-400 hover:text-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        {/* Body */}
        <div className="p-5 space-y-4">
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Esta acción es irreversible. Si quiere MANTENER el CHIP o UID asociado, primero ejecute la limpieza en ambos. Para confirmar que desea eliminar al cliente{" "}
            <strong className="text-red-500">{customerName}</strong> y todos sus datos asociados, por favor ingrese la contraseña de seguridad.
          </p>
          <div className="relative">
            <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña de seguridad"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent outline-none transition-all"
            />
          </div>
        </div>
        
        {/* Footer */}
        <div className="p-4 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-900/30 flex justify-end gap-3">
          <button 
            onClick={onClose}
            className="px-5 py-2 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-200 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-600 transition-all text-sm font-bold shadow-sm"
          >
            Cancelar
          </button>
          <button 
            onClick={handleConfirm}
            className="px-5 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-all text-sm font-bold shadow-sm disabled:bg-red-300 dark:disabled:bg-red-800 disabled:cursor-not-allowed"
            disabled={!password}
          >
            Eliminar Cliente
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCustomerModal;